import React from "react";

const DollarIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M15 9.5c-.6-1-1.7-1.5-3-1.5-1.8 0-3 .9-3 2s1 1.8 3 2 3 1 3 2-1.2 2-3 2c-1.3 0-2.4-.5-3-1.5M12 6v12" />
  </svg>
);

export default DollarIcon;
